var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file select组件
 * @author (wangzichuan)
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';

import { classPrefix } from '../../common/util';

import './SelectPanelItem.less';

var SelectPanelItem = function (_PureComponent) {
    _inherits(SelectPanelItem, _PureComponent);

    function SelectPanelItem() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SelectPanelItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectPanelItem.__proto__ || Object.getPrototypeOf(SelectPanelItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isShowTitle: false }, _this.onClickHandler = function (data) {
            var onClick = _this.props.onClick;
            _.isFunction(onClick) && onClick(data);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SelectPanelItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.itemDiv.scrollWidth > this.itemDiv.clientWidth) {
                this.setState({ isShowTitle: true });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this2 = this;

            var _props = this.props,
                active = _props.active,
                data = _props.data;

            var rootCls = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-select-panel-item', true), _defineProperty(_classnames, 'select-panel-item-active', active), _classnames));
            return React.createElement(
                'div',
                { className: rootCls,
                    ref: function ref(el) {
                        return _this2.itemDiv = el;
                    },
                    title: this.state.isShowTitle ? data.label : null,
                    onClick: function onClick() {
                        return _this2.onClickHandler(data);
                    }
                },
                data && data.label
            );
        }
    }]);

    return SelectPanelItem;
}(PureComponent);

SelectPanelItem.propTypes = {
    data: PropTypes.object,
    active: PropTypes.bool,
    onClick: PropTypes.func
};
export default SelectPanelItem;